import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
// 获取个人信息
import { getUserInfo, companyLogin } from 'api/login';
// 获取cookie
import { utilCookies } from '@/util/cookies';
export default {
  props: {
    title: {
      type: String,
      default: Vue.prototype.$t('login.28')
    }
  },
  data: function data() {
    return {
      passType: true,
      loading: false,
      // gl-button loading
      // 表单数据
      ruleForm: {
        c_id: '',
        // 登录公司的ID
        pwd: 'Aa23123',
        // 登录公司的密码
        currentCompany: ''
      },
      // 校验规则
      rules: {
        pwd: [{
          required: true,
          message: this.$t('262'),
          trigger: 'blur'
        }, {
          min: 6,
          message: this.$t('775'),
          trigger: 'blur'
        }],
        currentCompany: [{
          required: true,
          message: this.$t('774'),
          trigger: 'blur'
        }]
      },
      companyList: [],
      // 公司名称
      currentCompany: {}
    };
  },
  computed: {
    showResetPass: function showResetPass() {
      // 超级管理员具备重置密码的权限
      return this.ruleForm.currentCompany.type && this.ruleForm.currentCompany.type === '1';
    },
    selectCompanyStatus: function selectCompanyStatus() {
      if (!this.companyList || !Array.isArray(this.companyList) || this.companyList.length < 2 || Object.keys(this.currentCompany).length > 0) {
        return false;
      }
      return true;
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      // 初始化获取个人信息
      this.handleGetUserInfo();
    },
    // 密码显示隐藏切换
    changePass: function changePass() {
      this.passType = !this.passType;
    },
    // 获取个人信息
    handleGetUserInfo: function handleGetUserInfo() {
      var _this = this;
      getUserInfo().then(function (res) {
        // res.data.managed没数据跳转到不是管理员页面
        _this.companyList = [];
        if (res.data && res.data.managed) {
          _this.companyList = res.data.managed;
          if (_this.companyList.length === 1) {
            _this.currentCompany = _objectSpread(_objectSpread({}, res.data.user_info), _this.companyList[0]);
            _this.$s.set('baseInfo', res.data);
          } else {
            _this.currentCompany = {};
          }
          _this.$s.set('companyList', res.data.managed);
        } else {
          _this.$router.push({
            path: '/login/login-warning'
          });
        }
      });
    },
    // 创建公司
    createCallBack: function createCallBack() {
      this.handleGetUserInfo();
    },
    // 公司登录
    handleCompanyLogin: function handleCompanyLogin(item) {
      var _this2 = this;
      this.loading = true;
      companyLogin({
        c_id: item.c_id
      }).then(function (res) {
        // 登录公司埋点
        _this2.$ga.event('FHRSelectCompany', 'click', 'ScanQR', 18);
        var data = res.data;
        utilCookies.setCompanyToken(data.token);
        _this2.$s.set('currentCompany', data.info);
        window.location.reload();
      }).finally(function () {
        _this2.loading = false;
      });
    },
    onCreate: function onCreate() {
      // 注册企业埋点
      this.$ga.event('FHRLogin', 'click', 'TeamRegistration', 5);
    },
    goBack: function goBack() {
      utilCookies.removeToken();
      utilCookies.removeCompanyToken();
      window.location.reload();
    }
  }
};